/**
 * Scroll-triggered animations using Intersection Observer
 * Triggers reveal animations when elements enter the viewport
 */
(function() {
  'use strict';

  // Check for reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) {
    // If reduced motion is preferred, mark all elements as revealed immediately
    document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale, .check-list, .divider-animated').forEach(el => {
      el.classList.add('revealed');
    });
    return;
  }

  // Intersection Observer options
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px 300px 0px', // Pre-reveal below the fold so fast scrolling never lands on hidden content
    threshold: 0.1
  };

  // Create the observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Add revealed class to trigger animation
        entry.target.classList.add('revealed');

        // Unobserve after animation (performance optimization)
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Elements to observe
  const revealSelectors = [
    '.reveal',
    '.reveal-left',
    '.reveal-right',
    '.reveal-scale',
    '.check-list',
    '.divider-animated',
    '.stagger-children'
  ];

  // Initialize observations
  function init() {
    revealSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        observer.observe(el);
      });
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-observe on Shopify section render (for theme editor)
  document.addEventListener('shopify:section:load', () => {
    init();
  });

  // Parallax effect for hero sections
  const heroSections = document.querySelectorAll('.hero');

  if (heroSections.length > 0 && !prefersReducedMotion) {
    let ticking = false;

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrolled = window.pageYOffset;

          heroSections.forEach(hero => {
            const rect = hero.getBoundingClientRect();
            const heroTop = rect.top + scrolled;
            const heroHeight = rect.height;

            // Only apply parallax when hero is in view
            if (scrolled < heroTop + heroHeight) {
              const yPos = (scrolled - heroTop) * 0.3;
              hero.style.backgroundPositionY = `calc(50% + ${yPos}px)`;
            }
          });

          ticking = false;
        });

        ticking = true;
      }
    }, { passive: true });
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');

      if (targetId === '#') return;

      const target = document.querySelector(targetId);

      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

})();
